module.exports = __webpack_public_path__ + "static/elephant-480-54498a5e6769386f50696d3a21f54c3d.mp4";